import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Stack,
  Typography,
  Button,
  Divider,
  Grid,
  MenuItem,
  FormControl,
  FormHelperText,
  Select,
  InputLabel,
} from "@common-ui/ui";

import { createOrUpdateUserRole, getOrg } from "../../../services";

import MandatoryIcon from "../../../components/MandatoryIcon";

import { organizationSlice } from "../../../reducers/organizationReducer";

const RolePage = (props) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [initialRole, setInitialRole] = useState(
    JSON.parse(window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION"))
      ?.app_role
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      value: initialRole,
    },
    validationSchema: Yup.object({
      value: Yup.string().trim().required("Role is required"),
    }),
    onSubmit: async () => {
      setLoading(true);
      let { value } = formik.values;

      const attributes = {
        value: value,
      };

      try {
        await onSubmit(attributes, props.orgId);
        props.setToast([
          ...props.toast,
          {
            message: `User role updated successfully.`,
            open: true,
            severity: "success",
          },
        ]);

        formik.resetForm();
        // handleDialogClose();
      } catch (error) {
        setLoading(false);
        props.setToast([
          ...props.toast,
          {
            message: error.message,
            open: true,
            severity: "error",
          },
        ]);
        formik.setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    async function intialization() {
      try {
        const currentOrg = await getOrg(props.orgId);

        dispatch(organizationSlice.actions.setDefaultOrganization(currentOrg));
        dispatch(organizationSlice.actions.setCurrentOrganization(currentOrg));
        setInitialRole(
          JSON.parse(
            window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION")
          )?.app_role
        );
      } catch (error) {}
    }
    intialization();
  }, [formik, dispatch, props.orgId]);

  const onSubmit = async (attributes, orgId) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createOrUpdateUserRole(attributes, orgId);
        resolve({ payload: payload });
      } catch (error) {
        reject(error);
      }
    });
  };

  const handleDialogClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    formik.resetForm();
    props.history && props.history.push("/");
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Container maxWidth="md" component="main" sx={{ mt: 3 }}>
        <Stack direction="column">
          <Grid container spacing={2}>
            <Grid item md={3} xs={6}>
              <div>
                {/* <Typography variant="h4">Role</Typography> */}
                <InputLabel sx={{ display: "flex" }}>
                  <Typography variant="h5">User Role</Typography>
                  <MandatoryIcon />
                </InputLabel>
                <FormControl>
                  <Select
                    sx={{ width: 200 }}
                    size="small"
                    placeholder="Select"
                    fullWidth
                    name="value"
                    variant="outlined"
                    // helperText={formik.touched.value && formik.errors.value}
                    error={Boolean(formik.touched.value && formik.errors.value)}
                    value={formik.values.value}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <MenuItem value="Role" disabled>
                      <em>Role</em>
                    </MenuItem>
                    <MenuItem value={"ADMIN"}>Admin</MenuItem>
                    <MenuItem value={"SUPERVISOR"}>Supervisor</MenuItem>
                    <MenuItem value={"TECHNICIAN"}>Technician</MenuItem>
                  </Select>
                  {formik.touched.value && formik.errors.value && (
                    <FormHelperText>Field is required</FormHelperText>
                  )}
                </FormControl>
              </div>
            </Grid>
          </Grid>
        </Stack>
        <Divider sx={{ py: 1 }} />
      </Container>
      <Container maxWidth="md" component="main">
        <Stack
          direction={{ xs: "column", md: "row" }}
          justifyContent="flex-end"
          spacing={{ xs: 1, md: 2 }}
          sx={{ py: 2 }}
        >
          <div>
            <Button
              color="primary"
              fullWidth
              size="large"
              type="reset"
              onClick={handleDialogClose}
              variant="contained"
            >
              Cancel
            </Button>
          </div>
          <div>
            <Button
              color="primary"
              disabled={!(formik.isValid && formik.dirty) && !loading}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              onClick={formik.handleSubmit}
            >
              Save
            </Button>
          </div>
        </Stack>
      </Container>
    </form>
  );
};

export default RolePage;
